// src/components/QuantumToggle.jsx
import React from 'react';
import './QuantumToggle.css';

function QuantumToggle({ useQuantum, onToggle }) {
  return (
    <div className="quantum-toggle">
      <span className="toggle-label">Quantum Search</span>
      <label className="toggle-switch">
        <input 
          type="checkbox" 
          checked={useQuantum}
          onChange={onToggle}
        />
        <span className="slider"></span>
      </label>
      <span className="toggle-status">{useQuantum ? 'Enabled' : 'Disabled'}</span>
      <div className="toggle-tooltip">
        {useQuantum 
          ? "Using simulated quantum search for finding the best match" 
          : "Using classical algorithm to find the best match"}
      </div>
    </div>
  );
}

export default QuantumToggle;